import { getResponseData } from '../../../common/utils/api-utils';
import { getDefaultHeaders } from '../../../common/utils/auth-utils';

export async function getFetchWishListBySharingCodeApiCallMagento(apiUrl: string) {
  return await getResponseData(
    new Request(apiUrl, {
      method: 'GET',
      credentials: 'include',
      headers: getDefaultHeaders(),
    })
  );
}
